






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RelativeTime from "@/components/RelativeTime.vue";
import Toast from "bootstrap/js/src/toast";
import { ToastContent } from "@/store/toasts";

@Component({
  components: {
    RelativeTime
  }
})
export default class ToastItem extends Vue {
  private delay: number = parseInt(process.env.VUE_APP_TOAST_DURATION);
  private toast: Toast = (null as unknown) as Toast;

  @Prop({ required: true }) private content!: ToastContent;
  @Prop({ required: true }) private show!: boolean;

  private mounted() {
    this.$el.addEventListener("shown.bs.toast", this.shown);
    this.$el.addEventListener("hidden.bs.toast", this.hidden);
    this.toast = new Toast(this.$el, { delay: this.delay });
    this.toast.show();
  }

  private beforeDestroy() {
    this.$el.removeEventListener("shown.bs.toast", this.shown);
    this.$el.removeEventListener("hidden.bs.toast", this.hidden);
    this.toast.dispose();
  }

  private get background() {
    return `bg-${this.content.style}`;
  }

  private get color() {
    switch (this.content.style) {
      case "success":
      case "danger":
        return "text-white";
      case "warning":
      case "info":
        return "text-dark";
    }

    throw new Error(`Unexpected style value "${this.content.style}"`);
  }

  private shown() {
    this.$emit("shown");
  }

  private hidden() {
    this.$emit("hidden");
  }

  @Watch("show")
  private onShowChanged(show: boolean) {
    if (show) {
      this.toast.show();
    } else {
      this.toast.hide();
    }
  }
}
